import { createContext } from 'react';
import BookingService from '../Services/BookingService';

const BookingContext = createContext<BookingService>(new BookingService());
export default BookingContext;
